
export function inIframe () {
  if (window === window.parent) {
    return false
  }

  if (window.self === window.top) {
    return false
  }

  return true
}

const isIframe = () => {
  const testForcedIframe = () => {
    // NOTE: for manually test iframe download requests
    return window.forcedIframe
  }

  return testForcedIframe() || inIframe()
}

export default isIframe
